import glamorous from 'glamorous';

const SelectWrapper = glamorous.select(
  'ncss-select-menu pl4-sm pr10-sm u-full-width u-full-height',
  () => ({
    backgroundColor: '#031B39',
  }),
);
export default SelectWrapper;

SelectWrapper.displayName = 'SelectWrapper';




// WEBPACK FOOTER //
// ./src/components/ItemSelector/ItemSelector.style.js